const normalizeBase = (value) => {
    if (!value) return '';
    return value.replace(/\/+$/, '');
};

const defaultSiteUrl = 'https://code-pro.ir';
const apiBase =
    defaultSiteUrl;
export const API_BASE_URL = apiBase;
export const ADMIN_API_BASE = `${apiBase}/api/v1/admin`;
export const BLOG_API_BASE = `${apiBase}/api/v1/blog`;
export const APP_API_BASE = `${apiBase}/api/v1/app`;

export const SITE_BASE_URL =
    defaultSiteUrl;

const PUBLIC_S3_BASE = "https://content.code-pro.ir";

export function resolvePublicImageUrl(key) {
    if (!key) return "";
    // If it's a local preview (blob) or already a full URL, return as is
    if (key.startsWith("blob:") || key.startsWith("data:") || key.startsWith("http")) {
        return key;
    }
    // Append the public bucket base URL to the key
    return `${PUBLIC_S3_BASE}/${key}`;
}
